import { useState, useEffect } from 'react'; 
import { useStepContext } from "../../utils/StepContext.jsx"
import { useFormContext } from "../../utils/FormContext.jsx";
import { useMediaQuery } from 'react-responsive';
import { useAuth } from "../../utils/AuthContext/AuthContext.jsx";

import MainCard from "../MainCard.jsx";
import ProgressBar from "../ProgressBar/ProgressBar.jsx";
import SaveButton from "../SaveButton.jsx";
import PDFPreview from "../PDFPreview.jsx";
import HelpButton from "../HelpButton.jsx";
import ShishitoAssist from "../ShishitoAssist/ShishitoAssist.jsx";

const DisclosureInspection = () => {

    const { handleNext, handleBack } = useStepContext();
    const { formData, formId, handleDisclosureChange, handleDueDiligenceChange, handleOccupancyAgreementChange, handleOtherDocumentsChange, handleWaterRightsTextChange } = useFormContext(); 
    const { user }  = useAuth();
    const [isAssistVisible, setIsAssistVisible] = useState(false);

    const currentPageValue = 2;
    const currentSubStepProgress = 3/7; 
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    
    // console.log(formData);

    const toggleAssist = () => {
        setIsAssistVisible(!isAssistVisible);
    }

    const onNext = () => {
        handleNext();
    };

    return (
        <div className="w-full flex flex-col items-center">
        {/* <ProgressBar currentPage={currentPageValue} subStepProgress={currentSubStepProgress}/> */}
        <MainCard width={750} gap={0}>
        <div className="overflow-y-auto md:max-h-[425px] max-h-[45vh] w-full">
            <div className="inline-flex w-full gap-2 md:gap-0 justify-between mb-8">
            {isMobile ? <h3 className="text-black text-[18px] text-left font-normal font-['Inter']">Disclosures</h3> : <h3 className="text-black text-xl text-left font-normal font-['Inter']">Disclosures</h3>}
                <div className='h-auto gap-2 md:gap-4 items-center inline-flex'>
                    <HelpButton onClick={toggleAssist}/>
                    <SaveButton formData={formData} formId={formId}/>
                    {user && <PDFPreview formData={formData}/>}
                </div>
            </div>
            {/* <div className="flex flex-col w-full mb-8">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Leased Items</span>
                    <span className="w-[full h-auto text-shi-purple mb-2 text-[13px] md:text-xs font-['Inter']">Refers to if any leased personal property will be transferred to you, the buyer at closing. Typically No.</span>
                <div className="self-stretch justify-start gap-[25px] inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="yesLease" 
                            value="yes" 
                            checked={formData.leasedItems === 'yes'} 
                            onChange={(e) => handleDisclosureChange('leasedItems', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Yes</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="noLease"
                            value="no" 
                            checked={formData.leasedItems === 'no'} 
                            onChange={(e) => handleDisclosureChange('leasedItems', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">No</label>
                    </div>
                </div>
            </div>


            <div className="flex flex-col w-full mb-8">
                <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Encumbered Inclusion Documents</span>
                <span className="w-full md:w-[500px] h-auto text-shi-purple mb-2 text-xs font-['Inter']">Encumberances are liens, Easements, Deeds, etc. Will you the buyer assume the debt on these Encumberances. Most likely NO.</span>
                <div className="self-stretch justify-start gap-[25px] inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="encumberedYes" 
                            value="yes" 
                            checked={formData.encumberedInclusions === 'yes'} 
                            onChange={(e) => handleDisclosureChange('encumberedInclusions', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Yes</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="encumberedNo"
                            value="no" 
                            checked={formData.encumberedInclusions === 'no'} 
                            onChange={(e) => handleDisclosureChange('encumberedInclusions', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">No</label>
                    </div>
                </div>
            </div>   */}

            {/* <div className="flex flex-col w-full mb-8">
                <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Mineral Rights Review</span>
                <span className="w-full text-shi-purple mb-2 text-[13px] md:text-xs font-['Inter']">If there are no Mineral Rights on this property leave blank. If there are mineral rights do you maintain the right to terminate if Mineral Rights examination is unsatisfactory?</span>
                <div className="self-stretch justify-start gap-[25px] inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="mineralRightsReviewYes" 
                            value="yes" 
                            checked={formData.mineralRightsReview === 'yes'} 
                            onChange={(e) => handleDisclosureChange('mineralRightsReview', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Yes</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="mineralRightsReviewNo"
                            value="no" 
                            checked={formData.mineralRightsReview === 'no'} 
                            onChange={(e) => handleDisclosureChange('mineralRightsReview', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">No</label>
                    </div>
                </div>
            </div>  */}

            <div className="flex flex-col w-full mb-8">
                <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter] mb-2'>Is this contract conditional upon the sale of another property?</span>
                {/* <span className="w-full h-auto text-shi-purple mb-2 text-[13px] md:text-xs font-['Inter']">Will this contract be conditional upon the sale and closing of your current address you listed?</span> */}
                <div className="self-stretch justify-start gap-[25px] inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="conditionalUponSaleYes" 
                            value="yes" 
                            checked={formData.conditionalUponSale === 'yes'} 
                            onChange={(e) => handleDisclosureChange('conditionalUponSale', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Yes</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="conditionalUponSaleNo"
                            value="no" 
                            checked={formData.conditionalUponSale === 'no'} 
                            onChange={(e) => handleDisclosureChange('conditionalUponSale', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">No</label>
                    </div>
                </div>
            </div> 

        {/* DUE DILIGENCE SECTION */}

        {/* <div className={`flex flex-col w-full ${formData.dueDiligenceDocuments === 'yes' ? `mb-4` : `mb-8`}`}>
        <div className="self-stretch justify-start inline-flex items-center">
                <div className="flex flex-col text-left">
                    <div className="flex flex-col mb-2 justify-start">
                        <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Due Diligence Documents</span>
                        <span className="w-full h-auto text-shi-purple text-[13px] md:text-xs font-['Inter']">Default is N/A</span>
                    </div>
                    <div className="items-center gap-[25px] inline-flex">
                        <div className="items-center gap-2 flex">
                            <input 
                                type="radio" 
                                id="dueDiligenceDocumentsYes"
                                value="yes" 
                                checked={formData.dueDiligenceDocuments === 'yes'} 
                                onChange={(e) => handleDueDiligenceChange('dueDiligenceDocuments', e.target.value)}
                            />
                            <label className="text-black font-['Inter']">Yes</label>
                        </div>
                        <div className="items-center gap-2 flex">
                            <input 
                                type="radio" 
                                id="dueDiligenceDocumentsNo"
                                value="no" 
                                checked={formData.dueDiligenceDocuments === 'no'} 
                                onChange={(e) => handleDueDiligenceChange('dueDiligenceDocuments', e.target.value)}
                            />
                            <label className="text-black font-['Inter']">No</label>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        
            {formData.dueDiligenceDocuments === 'yes' && (   
            <div className="flex flex-col w-full">
                <div className="self-stretch justify-start flex-col items-center w-full">
                    <div className="flex flex-col w-full mb-8">
                        <div className="items-center flex">
                            <div className="w-full self-stretch justify-between gap-[10px] inline-flex items-center">
                                <div className="flex flex-col gap-2">
                                    <span className="w-full text-slate-600 text-sm">Add any additional due diligence documents you would like from the seller:</span>
                                    <textarea 
                                        name="dueDiligenceDocumentsText"
                                        className="w-full bg-slate-100 p-1.5" 
                                        onChange={handleWaterRightsTextChange}
                                        value={formData.dueDiligenceDocumentsText}
                                    />
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                     
            )}      */}

        {/* OCCUPANCY AGREEMENTS */}

        <div className={`flex flex-col w-full ${formData.occupancyAgreements === 'yes' ? `mb-4` : `mb-8`}`}>
        <div className="self-stretch justify-start inline-flex items-center">
                <div className="flex flex-col text-left">
                    <div className="flex flex-col mb-2 justify-start">
                        <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Will any existing lease agreements remain in place after you purchase the property?</span>
                        <span className="w-full h-auto text-shi-purple text-[13px] md:text-xs font-['Inter']">Select 'Yes' only if the property has tenants with lease agreements that will remain after closing. Otherwise, select 'No' or skip.</span>
                    </div>
                    {/*      */}
                    <div className="items-center gap-[25px] inline-flex">
                        <div className="items-center gap-2 flex">
                            <input 
                                type="radio" 
                                id="occupancyAgreementsYes"
                                value="yes" 
                                checked={formData.occupancyAgreements === 'yes'} 
                                onChange={(e) => handleOccupancyAgreementChange('occupancyAgreements', e.target.value)}
                            />
                            <label htmlFor="occupancyAgreementsYes" className="text-black font-['Inter']">Yes</label>
                        </div>
                        <div className="items-center gap-2 flex">
                            <input 
                                type="radio" 
                                id="occupancyAgreementsNo"
                                value="no" 
                                checked={formData.occupancyAgreements === 'no'} 
                                onChange={(e) => handleOccupancyAgreementChange('occupancyAgreements', e.target.value)}
                            />
                            <label htmlFor="occupancyAgreementsNo" className="text-black font-['Inter']">No</label>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        
            {formData.occupancyAgreements === 'yes' && (   
            <div className={`flex flex-col w-full ${formData.occupancyAgreements === 'yes' ? `mb-8` : `mb-0`}`}>
            <div className="self-stretch justify-start gap-[10px] flex-col items-center w-full">
                <div className="flex flex-col justify-start">
                    <div className="items-center flex">
                        <div className="w-full self-stretch justify-between gap-[10px] inline-flex items-center">
                            <div className="flex flex-col gap-2">
                                <span className="w-full text-slate-600 text-sm">Add any additional occupancy agreements such as leases on the property</span>
                                <textarea 
                                    name="occupancyAgreementsText"
                                    className="w-full bg-slate-100 p-1.5" 
                                    onChange={handleWaterRightsTextChange}
                                    value={formData.occupancyAgreementsText}
                                />
                            </div>
                            {/* <InfoSVG onClick={handleModalOpen}/> */}
                        </div>
                    </div>
                </div>
            </div>
            </div>
                     
            )}     

        {/* OTHER DOCUMENTS */}

        <div className="self-stretch justify-start inline-flex items-center">
            <div className="flex flex-col w-full mb-2">
                    <div className="flex flex-col mb-2 justify-start">
                        <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Other Documents</span>
                        <span className="w-full text-shi-purple text-[13px] md:text-xs font-['Inter']">We've already added default documents, but you can edit as needed</span>
                    </div>
                    <div className="items-center gap-2 inline-flex">
                        <div className="items-center gap-2 flex">
                            <input 
                                type="radio" 
                                id="otherDocumentsYes"
                                value="yes" 
                                checked={formData.otherDocuments === 'yes'} 
                                onChange={(e) => handleOtherDocumentsChange('otherDocuments', e.target.value)}
                            />
                            <label className="text-black font-['Inter']">Yes</label>
                        </div>
                        <div className="items-center gap-2 flex">
                            <input 
                                type="radio" 
                                id="otherDocumentsNo"
                                value="no" 
                                checked={formData.otherDocuments === 'no'} 
                                onChange={(e) => handleOtherDocumentsChange('otherDocuments', e.target.value)}
                            />
                            <label className="text-black font-['Inter']">No</label>
                        </div>
                    </div>
                </div>
            </div>
        
            {formData.otherDocuments === 'yes' && (   
            
            <div className="w-full justify-start gap-[10px] flex-col items-center">
                <div className="flex flex-col justify-start mb-4">
                    <div className="items-center flex">
                        <div className="w-full self-stretch justify-between gap-[10px] inline-flex items-center">
                            <div className="flex flex-col gap-2 w-full">
                                <span className="text-slate-600 text-sm">Add any additional documents</span>
                                <textarea 
                                    name="otherDocumentsText"
                                    className="w-full bg-slate-100 p-1.5" 
                                    onChange={handleWaterRightsTextChange}
                                    value={formData.otherDocumentsText}
                                />
                            </div>
                            {/* <InfoSVG onClick={handleModalOpen}/> */}
                        </div>
                    </div>
                </div>
            </div>
                     
            )}      
        </div>

            <div className="flex w-full justify-center gap-10 md:gap-36 mt-2 bg-white">
                <button className="w-[100px] md:w-[150px] justify-center text-center text-shi-green bg-white border-white text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-200 items-center md:items-start flex" onClick={handleBack}>
                    Back
                </button>
                <button className="w-[100px] md:w-[150px] justify-center items-center text-center text-white bg-shi-green text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-green-950 md:items-start flex" onClick={onNext}>
                    Next
                </button>
            </div>

        </MainCard>
        {isAssistVisible && (
                <div className="w-full md:w-auto absolute bottom-1 md:right-4">
                    <ShishitoAssist onClose={toggleAssist}/>
                </div>
            )}
        </div>
        
    )
}

export default DisclosureInspection; 